























































import { uploadImage } from '@/api/questionnaire'
import { defineComponent, ref } from '@vue/composition-api'
import { QuestionnairePageEntity } from '../../../../api/@types'
type Props = {
  page: QuestionnairePageEntity
}

export default defineComponent({
  props: {
    page: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props: Props, context) {
    const rules = [(v: any) => !!v || 'ページ名は必須項目です。']

    const input = ref({
      sentence: props.page.sentence || '',
      htmlContent: props.page.htmlContent || '',
      image: '',
    })

    const imageInput = ref({
      imageFile: null as File | null,
    })

    const save = () => {
      context.emit('submit', input.value)
    }

    const cancel = () => {
      context.emit('cancel')
    }

    const upload = async () => {
      if (!imageInput.value.imageFile) {
        return
      }

      input.value.image = await uploadImage(imageInput.value.imageFile)
    }

    const copyUrl = () => {
      if (window.navigator.clipboard === undefined) {
        return
      }
      window.navigator.clipboard.writeText(input.value.image || '')
    }

    return { input, imageInput, rules, save, cancel, upload, copyUrl }
  },
})
